import { auth, db } from "../../../firebaseConfig"; // Make sure to import your Firebase configuration
import { doc, setDoc } from "firebase/firestore";
import { getSelectedUid } from "../../../../frontend/Recruitment/Applications/Utils/UidListener";

// Function to save form data for Section 8
export const writeDataS8 = async (formData) => {
  const userId = getSelectedUid(); // Get the selected UID
  if (!userId) {
    throw new Error("Invalid user.");
  }
  try {
    const docRef = doc(
      db,
      "Advisers",
      userId,
      "Application Details",
      "Overall Financial Position"
    );

    await setDoc(
      docRef,
      {
        ...formData,
      },
      { merge: true }
    );
  } catch (error) {
    // console.error("Error writing Section 8 data to Firestore: ", error);
  }
};
